import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react';
import { TableHead } from '@/components/ui/table';
import { cn } from '@/lib/utils';

interface Props {
  label: string;
  active: boolean;
  // Only meaningful when active. Renders the up/down chevron.
  direction?: 'asc' | 'desc';
  align?: 'left' | 'right';
  onClick: () => void;
  className?: string;
}

// Clickable column header for sortable tables. Lives in /components/ui
// so both the Property Portal's Devices and Units tables (plus any
// future tables) can share the exact same sort affordance.
//
// The component is intentionally state-less — callers own the sortBy /
// sortDir state and decide what `active` + `direction` mean for each
// column. That keeps the same header usable against client-side sort
// (Units, memory) and server-side sort (Devices, URL-driven) without
// branching on the storage strategy.
export function SortableTableHead({ label, active, direction, align, onClick, className }: Props) {
  const Icon = active && direction
    ? direction === 'asc' ? ArrowUp : ArrowDown
    : ChevronsUpDown;
  return (
    <TableHead className={cn(align === 'right' ? 'text-right' : undefined, className)}>
      <button
        type="button"
        onClick={onClick}
        className={cn(
          'inline-flex items-center gap-1 select-none transition-colors',
          'hover:text-gray-900 dark:hover:text-gray-100',
          align === 'right' && 'flex-row-reverse',
          active && 'text-primary-700 dark:text-primary-300',
        )}
      >
        <span>{label}</span>
        <Icon className="w-3 h-3 opacity-60" />
      </button>
    </TableHead>
  );
}
